module.exports = __webpack_public_path__ + "static/media/Logo.c3cc3169.svg";